<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="integrarQockpitModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <img src="/qockpit.png" height="20"/>
                            Integrar Qockpit
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="dados">
                        <div class="alert alert-info" v-if="time_ref">
                            {{ format_mes_ano(time_ref) }}
                        </div>

                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th scope="col">ID</th>
                                    <th scope="col">Indicador</th>
                                    <th scope="col">Origem</th>
                                    <th scope="col">Frequência</th>
                                    <th scope="col" class="text-right">Numerador</th>
                                    <th scope="col" class="text-right">Denominador</th>
                                    <th scope="col" class="text-right">Valor</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(kpi,ikx) in kpis" :key="ikx">
                                    <td>
                                        <a :href="'/qockpit/kpi/' + kpi.id" target="_blank">
                                            #{{ kpi.id }}
                                        </a>
                                    </td>
                                    <td>
                                        {{ kpi.name }}
                                    </td>
                                    <td>
                                        {{ kpi.title }}
                                    </td>
                                    <td>
                                        {{ traduzir_freq(kpi.freq) }}
                                    </td>
                                    <td class="text-right">
                                        <span v-if="valores">
                                            {{ $util.formatMoeda(valores['kpi' + kpi.source_id]) }}
                                        </span>
                                    </td>
                                    <td class="text-right">
                                        {{ $util.formatMoeda(1) }}
                                    </td>
                                    <td class="text-right">
                                        <span v-if="valores">
                                            {{ $util.formatMoeda(valores['kpi' + kpi.source_id]) }}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <template v-if="retorno && retorno.kpis">

                            <hr>

                            <div class="alert alert-success">
                                Integração Realizada
                            </div>

                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">Id</th>
                                        <th scope="col">Registro</th>
                                        <th scope="col">Obs</th>
                                        <th scope="col" class="text-right">Valor</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(kpi,ikx) in retorno.kpis" :key="ikx">
                                        <td>
                                            <span v-if="kpi.out">
                                                #{{ kpi.out.kpi_id }}
                                            </span>
                                        </td>
                                        <td>
                                            <span v-if="kpi.out">
                                                {{ kpi.out.id }}
                                            </span>
                                        </td>
                                        <td>
                                            {{ kpi.msg }}
                                        </td>
                                        <td class="text-right">
                                            <span v-if="kpi.out">
                                                {{ $util.formatMoeda(kpi.out.value) }}
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar()" :disabled="retorno">Integrar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import AzSubmit from '../util/AzSubmit.vue';

export default {
    data() {
        return  { 
            dados: null, 
            fonte: null, 
            parms: null, 
            valores: null, 
            retorno: null, 
        };
    },

    components: { 
        AzSubmit 
    },
  
    computed: { 
        kpis: function () { 
            if ( !this.dados || !this.dados.custom || !this.dados.dashboard_items) { 
                return [];
            }

            console.log('DI', this.dados.dashboard_items);

            return this.dados.dashboard_items.filter(item => item.config && ( item.config.formula || ( item.config.q_kpi_id && item.config.q_kpi_freq == this.freq)))
                .map(item => { 
                    return { 
                        id: item.config.q_kpi_id, 
                        name: item.config.q_kpi_name, 
                        freq: item.config.q_kpi_freq,
                        title: item.title,
                        source_id: item.id,
                    }
                });
        },

        freq: function () { 
        
            if ( !this.parms ) { 
                return '';
            }

            let parm = this.parms.find(item => item.type == "per-date");

            if ( parm ) { 
                switch (parm.value) {
                    case 'm':
                    case 'ma':
                    case 'lm':
                        return 'm';

                    case 'a':
                    case 'aa':
                        return 'y';
                        
                }

            }

            return ''; 
        }

    },

    methods: { 
        format_mes_ano (mes) { 
            return this.$util.getFormatDate(mes, 'MM/YYYY');
        },

        atualizar () { 
            if ( !confirm('Deseja integrar os indicadores listados?') ) { 
                return;
            }

            this.$util.atualizar(this, { 
                service: 'dashboards',
                func: 'integrar_qockpit',
                dados: { 
                    ref: this.time_ref,
                    lista: this.kpis.map(kpi => { 
                        kpi.numerador = this.valores['kpi' + kpi.source_id];
                        kpi.denominador = 1;
                        return kpi;
                    })
                },
                callback: res => { 
                    this.retorno = res;
                }
            });
        },

        traduzir_freq (freq) { 
            switch (freq) { 
                case 'm':
                    return 'Mensal';
                case 'y':
                    return 'Anual';
                case 'd':
                    return 'Diário';
                case 'w':
                    return 'Semanal';
                default:
                    return freq;
            }
        },

        abrir(dados, fonte, parms) {
            this.dados = dados;
            this.parms = parms;
            this.time_ref = ""; 
            this.retorno = null;

            // Referência...

            this.valores = {};

            this.$nextTick(() => { 

                console.log('refs', this.$parent.$refs);

                this.kpis.forEach(kpi => {
                    console.log('kpi' + kpi.source_id);
                    let ref = this.$parent.$refs['kpi' + kpi.source_id];

                    console.log('ref', kpi.source_id, ( ref && ref[0] ) ? ref[0].valor : null, ref);

                    if ( ref && ref[0] ) { 
                        console.log('Aqui!!!');
                        this.valores['kpi' + kpi.source_id] = ref[0].valor;
                    }
                });

                console.log('valores', this.valores);

                this.$forceUpdate();

                //

                console.log('fonte', fonte);

                if ( this.freq == 'm' ) { 
                    
                    let primeiro = _.first(_.values(fonte));

                    this.time_ref = _.get(primeiro, 'data.info_periodo.de');

                    if ( this.time_ref ) { 
                        this.time_ref = this.time_ref.slice(0, 7);
                    }
                    
                } else { 

                    console.log('freq', this.freq);

                }

            });

            $('#integrarQockpitModal').modal('show');
        },
    }
}
</script>
